import React from 'react';
import { Box, Typography } from '@mui/material';

interface DaySelectionButtonProps {
  day: string;
  selectedDays: string[];
  toggleDay: () => void;
  disabled: boolean;
}

export const DaySelectionButton: React.FC<DaySelectionButtonProps> = ({
  day,
  selectedDays,
  toggleDay,
  disabled = false,
}) => {
  const isSelected = selectedDays.includes(day);
  
  return (
    <Box
    onClick={() => !disabled && toggleDay()}
      sx={{
        width: { xs: 'calc(25% - 6px)', sm: 'calc(14.28% - 6px)' },
        p: 1.5,
        border: '1px solid',
        borderColor: isSelected ? 'primary.main' : 'divider',
        borderRadius: 1,
        cursor: 'pointer',
        backgroundColor: isSelected ? 'rgba(149, 43, 179, 0.1)' : 'background.paper',
        textAlign: 'center',
        transition: 'all 0.2s',
        '&:hover': {
          borderColor: 'primary.main',
          backgroundColor: isSelected ? 'rgba(149, 43, 179, 0.1)' : 'rgba(0, 0, 0, 0.04)',
        },
      }}
    >
      <Typography variant='body2'>{day}</Typography>
    </Box>
  );
};